import * as types from './actionTypes';

export const get = (account_type, pageNumber=null) =>{
	return{
		type: types.API_CALL_ACCOUNT_REVIEW_REQUEST,
		account_type: account_type,
		pageNumber
	}
};

export const getSuccess = data => {
	return {
		type: types.PUT_ACCOUNT_REVIEW,
		payLoad: {data, loading: false}
	};
};
export const getFailure = () => {
	return {
		type: types.PUT_ACCOUNT_REVIEW,
		payLoad: {loading: false}
	};
};
export const selectTab = tabId => {
	return {
		type: types.SELECTED_TAB_ACCOUNT_REVIEW,
		payLoad: {selectedTab: tabId}
	};
};